import React from 'react';
import { useTranslation } from 'react-i18next';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import SectionHeading from '../SectionHeading';
import IconBoxStyle6 from '../IconBox/IconBoxStyle6';
import { pageTitle } from '../../helpers/PageTitle';
import Spacing from '../Spacing';
import SEO from '../SEO';

export default function Services() {
  const { t } = useTranslation();
  pageTitle(t('services.pageTitle'));

  const servicesData = [
    {
      title: t('services.service1Title'),
      subTitle: t('services.service1Description'),
      iconUrl: '/images/icons/professional.svg',
    },
    {
      title: t('services.service2Title'),
      subTitle: t('services.service2Description'),
      iconUrl: '/images/icons/comprehensive.svg',
    },
    {
      title: t('services.service3Title'),
      subTitle: t('services.service3Description'),
      iconUrl: '/images/icons/patient.svg',
    },
    {
      title: t('services.service4Title'),
      subTitle: t('services.service4Description'),
      iconUrl: '/images/icons/facilities.svg',
    },
    {
      title: t('services.service5Title'),
      subTitle: t('services.service5Description'),
      iconUrl: '/images/icons/professional.svg',
    },
    {
      title: t('services.service6Title'),
      subTitle: t('services.service6Description'),
      iconUrl: '/images/icons/comprehensive.svg',
    },
  ];

  return (
    <>
      <SEO title="Shërbimet" description="Shërbimet tona farmaceutike dhe medicinale - distribuim, partneritete dhe zgjidhje shëndetësore në Shqipëri." url="/services" />
      <BannerSectionStyle5
        bgUrl="/images/contact/banner_bg.svg"
        imgUrl="/images/services.svg"
        title={t('services.bannerTitle')}
        subTitle={t('services.bannerSubtitle')}
      />

      {/* Introduction Section */}
      <Section topMd={200} topLg={150} topXl={110}>
        <div className="container">
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <SectionHeading
                title={t('services.introTitle')}
                subTitle={t('services.introDescription')}
                center
              />
            </div>
          </div>
        </div>
      </Section>

      {/* Services Grid Section */}
      <Section topMd={100} topLg={80} topXl={60} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="container">
          <div className="row">
            {servicesData.map((item, index) => (
              <div className="col-lg-6" key={index}>
                <IconBoxStyle6 {...item} />
                <Spacing md="85" lg="60" xl="35" />
              </div>
            ))}
          </div>
        </div>
      </Section>
    </>
  );
}
